import { combineReducers } from "redux";
import current from "./current";
import list from "./list";
import loading from "./loading";
import teachers from "./teachers";
import courses from "./courses";



const reviews = combineReducers({
  teachers,
  courses,
  current,
  list,
  loading
});

export default reviews;